import { render, staticRenderFns } from "./EditPageAddresMain.vue?vue&type=template&id=6d35ceb0"
import script from "./EditPageAddresMain.vue?vue&type=script&lang=js"
export * from "./EditPageAddresMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports